import Base from "./Base";
import Typography from "@mui/material/Typography";
import {InputAdornment, Stack, TextField, useTheme} from "@mui/material";
import {Link} from "react-router-dom";
import Button from "@mui/material/Button";
import {useContext, useState} from "react";
import AuthContext from "../../context/AuthContext";
import IconButton from "@mui/material/IconButton";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";


const Login = () => {
    const theme = useTheme()
    const {loginUser} = useContext(AuthContext);
    const [passwordVisible, setPasswordVisible] = useState(false)

    return <Base>
        <div className="login-container">
            <div className="login-card">
                <form onSubmit={loginUser}>
                    <Stack spacing={{xs: 2}}>
                        <Typography variant="headline6" color={theme.palette.primary[600]}>Bejelentkezés</Typography>
                        <Stack spacing={1} marginBottom={2} marginTop={2}>
                            <Typography variant="caption" color={theme.palette.primary[500]}>Felhasználónév</Typography>
                            <TextField name="username" variant='standard'/>
                            <Typography variant="caption" color={theme.palette.primary[500]}>Jelszó</Typography>
                            <TextField name="password" type={passwordVisible ? "text" : "password"} variant='standard' InputProps={{
                                endAdornment: <InputAdornment position="end"><IconButton
                                    aria-label="toggle password visibility"
                                    onClick={() => setPasswordVisible(!passwordVisible)}
                                    edge="end"
                                >
                                    {passwordVisible ? <VisibilityOffRoundedIcon /> : <RemoveRedEyeRoundedIcon />}
                                </IconButton>
                                </InputAdornment>
                            }}/>
                        </Stack>
                        {/*<Link to="/forgot-password" style={{color: theme.palette.primary[600]}}>Elfelejtetted a jelszavad?</Link>*/}
                        <Button variant="contained" type="submit">Bejelentkezés</Button>
                    </Stack>
                </form>
            </div>
        </div>
    </Base>
}

export default Login